import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    DefaultDataServiceConfig,
    EntityDataModule,
    EntityDataService
} from '@ngrx/data';
import * as fromDataServices from '.';
import { LoggingService } from '../shared/services/logging';
import {
    AccrualPeriodDataService,
    entityName as accrualPeriodDataServiceName
} from './accrual-period/accrual-period.data-service';
import {
    BurdenDataService,
    entityName as burdenDataServiceName
} from './burden/burden.data-service';
import { ChargeNumberDataService } from './chargenumber';
import {
    CompanyAccessDataService,
    entityName as companyAccessDataServiceName
} from './company-access/company-access.data-service';
import { DeferBillingDataService } from './defer-billing';
import {
    EmailAuditDataService,
    entityName as emailAuditDataServiceName
} from './email-audit/email-audit.data-service';
import { defaultDataServiceConfig, entityConfig } from './entity-metadata';
import { FeeOnGADataService } from './fee-level/fee-on-ga';
import {
    entityName as invoiceContractCycleDataServiceName,
    InvoiceContractCycleDataService
} from './invoice-contract-cycle/invoice-contract-cycle.data-service';
import {
    entityName as invoiceRegisterDataServiceName,
    InvoiceRegisterDataService
} from './invoice-register/invoice-register.data-service';
import {
    entityName as invoiceAddressTypeDataServiceName,
    InvoiceAddressTypeDataService
} from './invoice/setup/invoice-address-type/invoice-address-type.data-service';
import {
    entityName as invoiceDetailOptionsDataServiceName,
    InvoiceDetailOptionsDataService
} from './invoice/setup/invoice-detail-options/invoice-detail-options.data-service';
import {
    entityName as invoicePropertyDataServiceName,
    InvoicePropertyDataService
} from './invoice/setup/invoice-property/invoice-property.data-service';
import {
    entityName as invoiceSessionTypeDataServiceName,
    InvoiceSessionTypeDataService
} from './invoice/setup/invoice-session-type/invoice-session-type.data-service';
import {
    entityName as jobAuditDataServiceName,
    JobAuditDataService
} from './job-audit/job-audit.data-service';
import {
    entityName as manageUsersDataServiceName,
    ManageUsersDataService
} from './manage-users/manage-users.data-service';
import { PtoPolicyAssignmentDataService } from './pto-policy/assignment';
import { PtoPolicySetupDataService } from './pto-policy/setup';
import { RateCeilingDataService } from './rate-ceiling';
import { entityName as recalculateSchedulesDataServiceName } from './recalculate-transactions/recalculate-schedules/recalculate-schedules.data-service';
import { TimecardSequenceDataService } from './timecard-sequence';
import { JobTimerDataService } from './job-timer/job-timer.data-service';
import { entityName as jobTimerDataServiceName } from './job-timer/job-timer.data-service';
import { ToasterDataService } from './toaster/toaster.data-service';
import { entityName as toasterDataServiceName } from './toaster/toaster.data-service';
import { RoleStatusDataService } from './dashboard/status/role-status.data-service';
import { entityName as roleStatusDataServiceName } from './dashboard/status/role-status.data-service';
import { FundingDataService } from './dashboard/funding/funding.data-service';
import { entityName as fundingDataServiceName } from './dashboard/funding/funding.data-service';
import { DRStatusDataService } from './dashboard/dr-status/dr-status.data-service';
import { entityName as drStatusDataServiceName } from './dashboard/dr-status/dr-status.data-service';
import { AccrualDataService } from './dashboard/accrual/accrual.data-service';
import { entityName as accrualDataServiceName } from './dashboard/accrual/accrual.data-service';
import { EmployeePayrollItemDataService } from './employee-payroll-item/employee-payroll-item.data-service';
import { entityName as employeePayrollItemDataServiceName } from './employee-payroll-item/employee-payroll-item.data-service';
import { DashboardSettingsDataService } from './dashboard-settings/dashboard-settings.data-service';
import { entityName as dashboardSettingsDataServiceName } from './dashboard-settings/dashboard-settings.data-service';
import { RatePlanningDataService } from './rate-planning/rate-planning.data-service';
import { entityName as ratePlanningDataServiceName } from './rate-planning/rate-planning.data-service';
import { IndirectRateAdjustDataService } from './indirect-rate-adjust/indirect-rate-adjust.data-service';
import { entityName as indirectRateAdjustDataServiceName } from './indirect-rate-adjust/indirect-rate-adjust.data-service';
import { RegistrationDataService } from './registration/registration.data-service';
import { entityName as registrationDataServiceName } from './registration/registration.data-service';
import { VendorDataService } from './vendor/vendor.data-service';
import { entityName as vendorDataServiceName } from './vendor/vendor.data-service';
import { PayrollExportDataService } from './payroll/payroll-export/payroll-export.data-service';
import { entityName as payrollExportDataServiceName } from './payroll/payroll-export/payroll-export.data-service';
import { MergeDataService, entityName as mergeDataServiceName } from './merge/merge.data-service';
import { InvoiceDataService } from './invoice/invoice.data-service';
import { entityName as invoiceDataServiceName } from './invoice/invoice.data-service';
import { CumulativeUploadDataService, entityName as cumulativeUploadDataServiceName } from './cumulative-upload/cumulative-upload.data-service';
import { EmployeeValidationDataService } from './employee-validation/employee-validation.data-service';
import { entityName as employeeValidationDataServiceName} from './employee-validation/employee-validation.data-service';
import { PayrollValidationDataService } from './payroll-validation/payroll-validation.data-service';
import { entityName as payrollValidationDataServiceName} from './payroll-validation/payroll-validation.data-service';
//import { TaskTimerDataService, entityName as taskTimerDataServiceName } from './task-timer/task-timer.data-service';

@NgModule({
    declarations: [],
    imports: [CommonModule, EntityDataModule.forRoot(entityConfig)],
    providers: [
        {
            provide: DefaultDataServiceConfig,
            useValue: defaultDataServiceConfig
        },
        fromDataServices.ProjectBudget.ProjectBudgetDataService,
        fromDataServices.Contract.Summary.ContractSummaryDataService,
        fromDataServices.Contract.ContractDataService,
        fromDataServices.PayrateOverride.PayrateOverrideDataService,
        fromDataServices.PremiumPay.PremiumPayDataService,
        fromDataServices.TimecardClass.TimecardClassDataService,
        fromDataServices.BudgetLevel.BudgetLevelDataService,
        fromDataServices.BudgetCycle.BudgetCycleDataService,
        fromDataServices.SignaturePolicy.SignaturePolicyDataService,
        fromDataServices.FeeHistory.FeeHistoryDataService,
        // fromDataServices.Reconciliation.Timecard.ReconciliationTimecardDataService,
        // fromDataServices.Reconciliation.PayperiodLabor.ReconciliationPayperiodLaborDataService,
        fromDataServices.Reconciliation.ReconciliationDataService,
        fromDataServices.Reconciliation.Fields.ReconciliationFieldDataService,
        fromDataServices.Reconciliation.Template
            .ReconciliationTemplateDataService,
        fromDataServices.ServiceItem.History.ServiceItemHistoryDataService,
        fromDataServices.Invoice.Setup.Invoice.InvoiceSetupDataService,
        fromDataServices.Invoice.Setup.Address.InvoiceAddressSetupDataService,
        fromDataServices.Invoice.Setup.Selections.InvoiceSelectionsDataService,
        fromDataServices.Invoice.Setup.Session.InvoiceSessionSetupDataService,
        fromDataServices.Address.AddressDataService,
        InvoiceSessionTypeDataService,
        InvoiceAddressTypeDataService,
        InvoicePropertyDataService,
        CompanyAccessDataService,
        fromDataServices.RecalculateSchedules.RecalculateSchedulesDataService,
        fromDataServices.RecalculateContracts.RecalculateContractsDataService,
        fromDataServices.RecalculateSettings.RecalculateSettingsDataService,
        fromDataServices.IndirectRateReview.IndirectRateReviewDataService,
        fromDataServices.DeferBilling.DeferBillingDataService,
        fromDataServices.PolicySetup.PtoPolicySetupDataService,
        fromDataServices.PolicyAssignment.PtoPolicyAssignmentDataService,
        ManageUsersDataService,
        FeeOnGADataService,
        AccrualPeriodDataService,
        EmailAuditDataService,
        BurdenDataService,
        JobAuditDataService,
        fromDataServices.IndirectRateHistory.IndirectRateHistoryDataService,
        TimecardSequenceDataService,
        InvoiceContractCycleDataService,
        InvoiceDetailOptionsDataService,
        ChargeNumberDataService,
        InvoiceRegisterDataService,
        JobTimerDataService,
        ToasterDataService,
        RoleStatusDataService,
        FundingDataService,
        DRStatusDataService,
        AccrualDataService,
        EmployeePayrollItemDataService,
        DashboardSettingsDataService,
        RatePlanningDataService,
        IndirectRateAdjustDataService,
        RegistrationDataService,
        VendorDataService,
        PayrollExportDataService,
        MergeDataService,
        InvoiceDataService,
        CumulativeUploadDataService,
        EmployeeValidationDataService,
        PayrollValidationDataService,
        //TaskTimerDataService
    ]
})
export class DataServicesModule {
    constructor(
        private log: LoggingService,
        entityDataService: EntityDataService,
        projectBudgetdataService: fromDataServices.ProjectBudget.ProjectBudgetDataService,
        contractSummaryDataService: fromDataServices.Contract.Summary.ContractSummaryDataService,
        contractDataService: fromDataServices.Contract.ContractDataService,
        payrateOverrideDataService: fromDataServices.PayrateOverride.PayrateOverrideDataService,
        premiumPayService: fromDataServices.PremiumPay.PremiumPayDataService,
        timecardClassDataService: fromDataServices.TimecardClass.TimecardClassDataService,
        budgetLevelDataService: fromDataServices.BudgetLevel.BudgetLevelDataService,
        budgetCycleDataService: fromDataServices.BudgetCycle.BudgetCycleDataService,
        signaturePolicyDataService: fromDataServices.SignaturePolicy.SignaturePolicyDataService,
        feeHistoryDataService: fromDataServices.FeeHistory.FeeHistoryDataService,
        reconciliationDataService: fromDataServices.Reconciliation.ReconciliationDataService,
        reconciliationFieldsDataService: fromDataServices.Reconciliation.Fields.ReconciliationFieldDataService,
        reconciliationTemplateDataService: fromDataServices.Reconciliation.Template.ReconciliationTemplateDataService,
        serviceItemHistoryDataService: fromDataServices.ServiceItem.History.ServiceItemHistoryDataService,
        invoiceSetupDataService: fromDataServices.Invoice.Setup.Invoice.InvoiceSetupDataService,
        invoiceSelectionsSetupDataService: fromDataServices.Invoice.Setup.Selections.InvoiceSelectionsDataService,
        invoiceAddressSetupDataService: fromDataServices.Invoice.Setup.Address.InvoiceAddressSetupDataService,
        invoiceSessionSetupDataService: fromDataServices.Invoice.Setup.Session.InvoiceSessionSetupDataService,
        addressDataService: fromDataServices.Address.AddressDataService,
        invoiceSessionTypeDataService: InvoiceSessionTypeDataService,
        invoiceAddressTypeDataService: InvoiceAddressTypeDataService,
        invoicePropertyDataService: InvoicePropertyDataService,
        companyAccessDataService: CompanyAccessDataService,
        recalculateSchedulesDataService: fromDataServices.RecalculateSchedules.RecalculateSchedulesDataService,
        recalculateContractsDataService: fromDataServices.RecalculateContracts.RecalculateContractsDataService,
        recalculateSettingsDataService: fromDataServices.RecalculateSettings.RecalculateSettingsDataService,
        indirectRateReviewDataService: fromDataServices.IndirectRateReview.IndirectRateReviewDataService,
        deferBillingDataService: DeferBillingDataService,
        manageUsersDataService: ManageUsersDataService,
        feeOnGADataService: FeeOnGADataService,
        accrualPeriodDataService: AccrualPeriodDataService,
        policySetupDataService: PtoPolicySetupDataService,
        policyAssignmentDataService: PtoPolicyAssignmentDataService,
        emailAuditDataService: EmailAuditDataService,
        burdenDataService: BurdenDataService,
        jobAuditDataService: JobAuditDataService,
        rateCeilingDataService: RateCeilingDataService,
        indirectRateHistoryDataService: fromDataServices.IndirectRateHistory.IndirectRateHistoryDataService,
        timecardSequenceDataService: TimecardSequenceDataService,
        invoiceContractCycleDataService: InvoiceContractCycleDataService,
        invoiceDetailOptionsDataService: InvoiceDetailOptionsDataService,
        chargeNumberDataService: ChargeNumberDataService,
        invoiceRegisterDataService: InvoiceRegisterDataService,
        jobTimerDataService: JobTimerDataService,
        toasterDataService: ToasterDataService,
        roleStatusDataService: RoleStatusDataService,
        fundingDataService: FundingDataService,
        drStatusDataService: DRStatusDataService,
        accrualDataService: AccrualDataService,
        employeePayrollItemDataService: EmployeePayrollItemDataService,
        dashboardSettingsDataService: DashboardSettingsDataService,
        ratePlanningDataService: RatePlanningDataService,
        indirectRateAdjustDataService: IndirectRateAdjustDataService,
        registrationDataService: RegistrationDataService,
        vendorDataService: VendorDataService,
        payrollExportDataService: PayrollExportDataService,
        mergeDataService: MergeDataService,
        invoiceDataService: InvoiceDataService,
        cumulativeUploadDataService: CumulativeUploadDataService,
        employeeValidationDataService: EmployeeValidationDataService,
        payrollValidationDataService: PayrollValidationDataService
        //taskTimerDataService: TaskTimerDataService
    ) {
        this.log.verbose({ type: 'DataServicesModule::' });
        entityDataService.registerService(
            fromDataServices.FeeOnGA.entityName,
            feeOnGADataService
        );
        entityDataService.registerService(
            fromDataServices.DeferBilling.entityName,
            deferBillingDataService
        );
        entityDataService.registerService(
            fromDataServices.RecalculateSchedules.entityName,
            recalculateSchedulesDataService
        );
        entityDataService.registerService(
            fromDataServices.RecalculateContracts.entityName,
            recalculateContractsDataService
        );
        entityDataService.registerService(
            fromDataServices.RecalculateSettings.entityName,
            recalculateSettingsDataService
        );
        entityDataService.registerService(
            fromDataServices.ProjectBudget.entityName,
            projectBudgetdataService
        );
        entityDataService.registerService(
            fromDataServices.Contract.Summary.entityName,
            contractSummaryDataService
        );
        entityDataService.registerService(
            fromDataServices.Contract.entityName,
            contractDataService
        );
        entityDataService.registerService(
            fromDataServices.PayrateOverride.entityName,
            payrateOverrideDataService
        );
        entityDataService.registerService(
            fromDataServices.PremiumPay.entityName,
            premiumPayService
        );
        entityDataService.registerService(
            fromDataServices.TimecardClass.entityName,
            timecardClassDataService
        );
        entityDataService.registerService(
            fromDataServices.BudgetLevel.entityName,
            budgetLevelDataService
        );
        entityDataService.registerService(
            fromDataServices.BudgetCycle.entityName,
            budgetCycleDataService
        );
        entityDataService.registerService(
            fromDataServices.SignaturePolicy.entityName,
            signaturePolicyDataService
        );
        entityDataService.registerService(
            fromDataServices.FeeHistory.entityName,
            feeHistoryDataService
        );
        entityDataService.registerService(
            fromDataServices.Reconciliation.entityName,
            reconciliationDataService
        );
        entityDataService.registerService(
            fromDataServices.Reconciliation.Fields.entityName,
            reconciliationFieldsDataService
        );
        entityDataService.registerService(
            fromDataServices.Reconciliation.Template.entityName,
            reconciliationTemplateDataService
        );
        entityDataService.registerService(
            fromDataServices.ServiceItem.History.entityName,
            serviceItemHistoryDataService
        );
        entityDataService.registerService(
            fromDataServices.Invoice.Setup.Invoice.entityName,
            invoiceSetupDataService
        );
        entityDataService.registerService(
            fromDataServices.Invoice.Setup.Selections.entityName,
            invoiceSelectionsSetupDataService
        );
        entityDataService.registerService(
            fromDataServices.Invoice.Setup.Address.entityName,
            invoiceAddressSetupDataService
        );
        entityDataService.registerService(
            fromDataServices.Invoice.Setup.Session.entityName,
            invoiceSessionSetupDataService
        );
        entityDataService.registerService(
            fromDataServices.Address.entityName,
            addressDataService
        );
        entityDataService.registerService(
            invoiceSessionTypeDataServiceName,
            invoiceSessionTypeDataService
        );
        entityDataService.registerService(
            invoiceAddressTypeDataServiceName,
            invoiceAddressTypeDataService
        );
        entityDataService.registerService(
            invoicePropertyDataServiceName,
            invoicePropertyDataService
        );
        entityDataService.registerService(
            companyAccessDataServiceName,
            companyAccessDataService
        );
        entityDataService.registerService(
            recalculateSchedulesDataServiceName,
            recalculateSchedulesDataService
        );
        entityDataService.registerService(
            fromDataServices.IndirectRateReview.entityName,
            indirectRateReviewDataService
        );
        entityDataService.registerService(
            manageUsersDataServiceName,
            manageUsersDataService
        );
        entityDataService.registerService(
            accrualPeriodDataServiceName,
            accrualPeriodDataService
        );
        entityDataService.registerService(
            fromDataServices.PolicySetup.entityName,
            policySetupDataService
        );
        entityDataService.registerService(
            fromDataServices.PolicyAssignment.entityName,
            policyAssignmentDataService
        );
        entityDataService.registerService(
            fromDataServices.RateCeiling.entityName,
            rateCeilingDataService
        );
        entityDataService.registerService(
            emailAuditDataServiceName,
            emailAuditDataService
        );
        entityDataService.registerService(
            burdenDataServiceName,
            burdenDataService
        );
        entityDataService.registerService(
            jobAuditDataServiceName,
            jobAuditDataService
        );
        entityDataService.registerService(
            fromDataServices.IndirectRateHistory.entityName,
            indirectRateHistoryDataService
        );
        entityDataService.registerService(
            fromDataServices.TimecardSequence.entityName,
            timecardSequenceDataService
        );
        entityDataService.registerService(
            invoiceContractCycleDataServiceName,
            invoiceContractCycleDataService
        );
        entityDataService.registerService(
            invoiceDetailOptionsDataServiceName,
            invoiceDetailOptionsDataService
        );
        entityDataService.registerService(
            fromDataServices.ChargeNumber.entityName,
            chargeNumberDataService
        );
        entityDataService.registerService(
            invoiceRegisterDataServiceName,
            invoiceRegisterDataService
        );
        entityDataService.registerService(
            jobTimerDataServiceName,
            jobTimerDataService
        );
        entityDataService.registerService(
            toasterDataServiceName,
            toasterDataService
        );
        entityDataService.registerService(
            roleStatusDataServiceName,
            roleStatusDataService
        );
        entityDataService.registerService(
            fundingDataServiceName,
            fundingDataService
        );
        entityDataService.registerService(
            drStatusDataServiceName,
            drStatusDataService
        );
        entityDataService.registerService(
            accrualDataServiceName,
            accrualDataService
        );
        entityDataService.registerService(
            employeePayrollItemDataServiceName,
            employeePayrollItemDataService
        );
        entityDataService.registerService(
            dashboardSettingsDataServiceName,
            dashboardSettingsDataService
        );
        entityDataService.registerService(
            ratePlanningDataServiceName,
            ratePlanningDataService
        );
        entityDataService.registerService(
            indirectRateAdjustDataServiceName,
            indirectRateAdjustDataService
        );
        entityDataService.registerService(
            registrationDataServiceName,
            registrationDataService
        );
        entityDataService.registerService(
            vendorDataServiceName,
            vendorDataService
        );
        entityDataService.registerService(
            payrollExportDataServiceName,
            payrollExportDataService
        );
        entityDataService.registerService(
            invoiceDataServiceName,
            invoiceDataService
        );
        entityDataService.registerService(
            mergeDataServiceName,
            mergeDataService
        );
        entityDataService.registerService(
            cumulativeUploadDataServiceName,
            cumulativeUploadDataService
        );
        // entityDataService.registerService(
        //     taskTimerDataServiceName,
        //     taskTimerDataService
        // );
            entityDataService.registerService(
            employeeValidationDataServiceName,
            employeeValidationDataService
        );
        entityDataService.registerService(
            payrollValidationDataServiceName,
            payrollValidationDataService
        );
}
}
